import { render, staticRenderFns } from "./ContrastSchool.vue?vue&type=template&id=97480fbe&scoped=true"
import script from "./ContrastSchool.vue?vue&type=script&lang=js"
export * from "./ContrastSchool.vue?vue&type=script&lang=js"
import style0 from "./ContrastSchool.vue?vue&type=style&index=0&id=97480fbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97480fbe",
  null
  
)

export default component.exports